import MeaPage from "../../../components/MeaPage";
import { useEffect, useRef, useState } from "react";
import trainingsAPI from "../../../services/trainings";
import useAuthContext from "../../../hooks/useAuthContext";
import tasksAPI from "../../../services/tasks";
import levelsAPI from "../../../services/levels";
import ExportRegistrationsComponent from "./components/ExportRegistrationsComponent";
import { useParams } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ExportRegistrationsPage = () => {
  //
  const params = useParams();
  const schoolId = params.schoolId
  const trainingId = params.registrationId;

  return (
    <>
      <MeaPage title="Exporter la liste des élèves" subtitle="Exporter la liste des élèves vers un fichier excel">
        <ExportRegistrationsComponent schoolId={schoolId} trainingId={trainingId} />
      </MeaPage>
    </>
  );
}
export default ExportRegistrationsPage;
